import BreadCrumb from "../../../components/BreadCrumb";
import Layout from "../../../components/Layout";
import { toast } from "react-toastify";
import { useUserState } from "../../../context/UserContext";
import Button from "../../../components/Button";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import Modal from "../../../components/Modal";
import { httprequest } from "../../../data/api";

import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { uploadFile } from "../../../hooks/useUpload";
import NoData from "../../dashboard/components/NotFoundCard/NoData";
import nosearch from "../../../assets/images/no-search.svg";
import PageLoader from "../../../components/PageLoader";
import Template1 from "../Template/FirstReport";
import Template2 from "../Template/SecondReport";
import Template3 from "../Template/ThirdReport";

// const CLASSES_ENDPOINT = "/api/v1/class";
const REPORT_ENDPOINT = "/api/v1/student-report/";
const EXTRAS_ENDPOINT = "/api/v1/school-extras";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";

const FirstReport = () => {
  const reportRef = useRef();
  const { id } = useParams();
  const { userRole, appLogo, profile } = useUserState();
  const [isPublishing, setIsPublishing] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [publishModal, setPublishModal] = useState(false);
  const [obtainablescore, setObtainableScore] = useState([]);
  // const [allStudent, setAllStudents] = useState([]);
  // const [selectedStudents, setSelectedStudents] = useState([]);
  // const [classesData, setClassData] = useState([]);
  const isTeacher = userRole?.role_type === "employee";
  const isAdmin = userRole?.role_type === "school_admin";
  const [reportData, setReportData] = useState([]);
  const [extraData, setExtrasData] = useState([]);
  const [isPageFetching, setIsPageFetching] = useState(false);

  const navigate = useNavigate();

  const handlePublishModal = () => {
    if (publishModal) {
      // setSelectedClassId(null);
      // setAllStudents([]);
      // setSelectedStudents([]);
    }
    setPublishModal(!publishModal);
  };

  const handleViewReport = useCallback(async () => {
    setIsPageFetching(true);

    try {
      let response;
      const urlParams = new URLSearchParams(window.location.search);
      const termId = urlParams.get("term_id");
      const classId = urlParams.get("class_id");

      if (window.location.pathname.includes("student/")) {
        const studentId = id.replace("student/", "");
        const queryParams = [];

        if (studentId) queryParams.push(`student_id=${id}`);
        if (termId) queryParams.push(`term_id=${termId}`);
        if (classId) queryParams.push(`class_id=${classId}`);

        const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
        response = await httprequest.get(`/api/v1/student-reports/combine${queryString}`);
      } else {
        response = await httprequest.get(`${REPORT_ENDPOINT}?report_ids=${id}`);
      }

      const responseData = response?.data?.data;

      setReportData(Array.isArray(responseData) ? responseData[0] : responseData);
    } catch (error) {
      toast.error(error.response?.data?.message || error.message || "Failed to load report");
    } finally {
      setIsPageFetching(false);
    }
  }, [id]);

  const getAllExtras = () => {
    httprequest
      .get(EXTRAS_ENDPOINT)
      .then((res) => {
        setExtrasData(res.data.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const handleEditReport = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const termId = urlParams.get("term_id");
    const classId = urlParams.get("class_id");

    const queryParams = new URLSearchParams();

    if (window.location.pathname.includes("student/")) {
      const studentId = id.replace("student/", "");
      if (studentId) queryParams.append("student_id", studentId);
      if (termId) queryParams.append("term_id", termId);
      if (classId) queryParams.append("class_id", classId);

      navigate(`/report/editreport/student/${studentId}?${queryParams.toString()}`);
    } else {
      navigate(`/report/editreport/${id}`);
    }
  };

  const handleGenerateAndUploadPDF = async () => {
    setIsGeneratingPDF(true);
    try {
      document.body.classList.add("printing-pdf");

      const element = reportRef.current;

      // Optimized html2canvas options
      const options = {
        scale: 1,
        useCORS: true,
        allowTaint: false,
        logging: false,
        backgroundColor: "#FFFFFF",
        removeContainer: true,
        ignoreElements: (el) => el.style.display === "none" || el.offsetWidth === 0
      };

      const canvas = await html2canvas(element, options);
      document.body.classList.remove("printing-pdf");

      // eslint-disable-next-line new-cap
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4",
        compress: true
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgData = canvas.toDataURL("image/jpeg", 0.85);
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);

      let heightLeft = imgHeight;
      let position = 0;
      const pageHeight = pdf.internal.pageSize.getHeight() - 20;

      while (heightLeft >= 0) {
        position = heightLeft - pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      const pdfBlob = pdf.output("blob");
      setIsUploading(true);

      const uploadResponse = await uploadFile(pdfBlob, `${reportData?.last_name}_report.pdf`);

      return uploadResponse;
    } catch (error) {
      document.body.classList.remove("printing-pdf");
      toast.error("PDF generation failed");
      throw error;
    } finally {
      setIsGeneratingPDF(false);
      setIsUploading(false);
    }
  };

  const handlePublishReport = async () => {
    setIsPublishing(true);

    try {
      const uploadResponse = await handleGenerateAndUploadPDF();

      const documentData = uploadResponse[0];

      const publishPayload = {
        reports: [{
          report_id: id,
          document: {
            upload_id: documentData.upload_id,
            file_url: documentData.file_url,
            name: `${reportData?.last_name} ${reportData?.first_name} Report`
          }
        }]
      };

      const response = await httprequest.post("/api/v1/student-reports/publish", publishPayload);

      toast.success(response.data.message || "Report published successfully");
      handlePublishModal(); // Close the modal
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to publish report");
    } finally {
      setIsPublishing(false);
    }
  };

  /**
         * Fetches all obtainable scores from the API
         */
  const getAllObtainableScores = (session_id) => {
    // setIsLoading(true);
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.filter((scores) => scores?.session?.id === session_id));
        // setIsLoading(false);
      })
      .catch((err) => {
        // setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    handleViewReport();
    getAllExtras();
  }, []);

  useEffect(() => {
    if (reportData?.session?.id) {
      getAllObtainableScores(reportData.session.id);
    }
  }, [reportData?.session?.id]);

  const template = profile?.report_template?.template_id;

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one={`${isTeacher ? "/reports/reports" : isAdmin ? "/report/reports" : "/profile"}`}
                link_one_name="Report"
                active="View Report"
                description="View report details here"
              />
            </div>
          </div>
          {isPageFetching ? (
            <PageLoader />
          ) : (
            <>
              {!reportData || Object.keys(reportData).length === 0 ? (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="page-content container-border">
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <NoData
                      title="Report Unavailable"
                      subtitle="No Result uploaded or is currently being processed"
                      img={nosearch}
                    />
                    <Button
                      variant="primary"
                      buttonSize="medium"
                      color="btndefault"
                      buttonName="Return To Report"
                      onClick={handleGoBack}
                    />
                  </div>
                </div>
              ) : (
                <>
                  {template === "template-1" ? (
                    <Template1
                      reportData={reportData}
                      obtainablescore={obtainablescore}
                      extraData={extraData}
                      appLogo={appLogo}
                      reportRef={reportRef}
                      profile={profile}
                    />
                  ) : template === "template-2" ? (
                    <Template2
                      reportData={reportData}
                      obtainablescore={obtainablescore}
                      extraData={extraData}
                      appLogo={appLogo}
                      reportRef={reportRef}
                      profile={profile}
                    />
                  ) : template === "template-3" ? (
                    <Template3
                      reportData={reportData}
                      obtainablescore={obtainablescore}
                      extraData={extraData}
                      appLogo={appLogo}
                      reportRef={reportRef}
                      profile={profile}
                    />
                  ) :
                    <Template1
                      reportData={reportData}
                      obtainablescore={obtainablescore}
                      extraData={extraData}
                      appLogo={appLogo}
                      reportRef={reportRef}
                      profile={profile}
                    />
                  }

                  {isAdmin || isTeacher ?
                    <div className="flex gap-10 margin-top-30">
                      <Button
                        variant="primaryoutline"
                        buttonSize="medium"
                        color="btnfontprimary"
                        buttonName="Edit Report"
                        onClick={handleEditReport}
                      />
                      {reportData?.status === "ready_for_publish" ? (
                        <Button
                          variant="primary"
                          buttonSize="medium"
                          color="btndefault"
                          buttonName="Publish Report"
                          onClick={handlePublishModal}
                        />
                      ) : null}
                    </div>
                    : null}
                </>
              )}
            </>
          )}

          <Modal
            title="Publish Report"
            subtitle="Publish Student Report"
            // modalContent={
            //   <>
            //     <Grid container spacing={2} className="input-padding">
            //       <Grid item lg={12} md={12} sm={12} xs={12}>
            //         <SelectGroup
            //           label="Select Class"
            //           required
            //           children={
            //             <select
            //               name="class_id"
            //               onChange={handleClassChange}
            //             >
            //               <option value="">--- Select ---</option>
            //               {classesData?.map((clss) => {
            //                 return (
            //                   <option key={clss?.id} value={clss?.id}>
            //                     {clss?.class_name}
            //                   </option>
            //                 );
            //               })}
            //             </select>
            //           }
            //         />
            //       </Grid>
            //       <Grid item lg={12} md={12} sm={12} xs={12}>
            //         <div className="multiple-select">
            //           <p>Select Student</p>
            //           <Select name="student_id"
            //             isMulti
            //             isClearable
            //             isSearchable
            //             options={selectedClassId ? [
            //               { value: "all", label: "Select All" },
            //               ...allStudent
            //             ] : allStudent}
            //             value={selectedStudents}
            //             onChange={handleStudentChange}
            //             getOptionLabel={(option) => option?.label}
            //             getOptionValue={(option) => option?.value}
            //             menuPortalTarget={document.body}
            //             styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            //           />
            //         </div>
            //       </Grid>
            //     </Grid>
            //   </>
            // }
            modalFooter={
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  isLoading={isPublishing || isUploading || isGeneratingPDF}
                  buttonName={
                    isPublishing ? "Publishing..." :
                      isUploading ? "Uploading..." :
                        isGeneratingPDF ? "Generating PDF..." :
                          "Publish"
                  }
                  onClick={handlePublishReport}
                />
                {/* <Button
                  variant="primaryoutline"
                  buttonSize="full"
                  color="btnfontprimary"
                  buttonName="Publish and Send Report"
                /> */}
              </div>
            }
            isopen={publishModal}
            closeModal={handlePublishModal}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default FirstReport;
